module.exports = __webpack_public_path__ + "static/media/nft-36.2a8d76cb.jpg";